import { AttendeeCourseWaitingPositionState } from './types';

export const state = (): AttendeeCourseWaitingPositionState => initialState();

export const initialState = (): AttendeeCourseWaitingPositionState => ({
  attendeeCourseWaitingPositions: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['position'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['firstName', 'lastName', 'email'],
    },
  },
  // A second list of waiting list entries to have another waiting list table open at the same time
  attendeeCourseWaitingPositionsSecond: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['position'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['firstName', 'lastName', 'email'],
    },
  },
});
